import { api } from "@ts/core/api";
import { Cookie } from "@ts/core/Cookie";
import { Elements } from "@ts/core/Elements";
import { simpleForm } from "@ts/core/SimpleForm";
import { HtmlData } from "@ts/data/HtmlData";
import { HtmlSection } from "@ts/sections/HtmlSection";

export function createHeadingSection(): Promise<boolean> {

    return new Promise((resolve) => {
        simpleForm('Rubrik', 1, 'Skriv en rubriken', '',
            'Skriv din rubrik här')
            .then(
                async (text: string) => {
                    const data = new Object as HtmlData;
                    data.htmlcode = text;
                    data.sectiontype = 'html';
                    data.subtype = 'heading';
                    data.public = false;
                    data.htmlid = 0;
                    data.sectionid = 0;
                    data.htmlcode = `<h1>${text}</h1>`;

                    const resp = await api<{ data: HtmlData }>('createSection', {
                        pos: Elements.contentContainer.childElementCount,
                        pagename: Cookie.pagename,
                        data: data,
                        type: 'html'
                    });
                    if (resp) {
                        const section = new HtmlSection(resp.data);
                        section.render();
                        section.enableEdit = true;
                        section.beginEdit();
                        resolve(true);
                    }
                    resolve(false);
                },
                () => {
                    resolve(false);
                }
            );
    });
}